import { IPhamViBan } from "./../../../model/respone/category/IPhamViBan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhamViBanActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPhamViBan[],
  LOAD_ERRR: "",

  SHOW_MODAL: {} as IPhamViBan | undefined,
  CLOSE_MODAL: undefined,

  SAVE_START: {} as IPhamViBan,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};
export const ePhamViBanActionIds = generateActionTypeIds(
  ePhamViBanActionsObj,
  "PHAM_VI_BAN"
);
export type IPhamViBanActionTypes = IGenericActionType<
  typeof ePhamViBanActionsObj,
  "PHAM_VI_BAN"
>;
